import ContourUniform from './shaders.contour.uniform';
import ContourFragment from './shaders.contour.fragment';
import ContourVertex from './shaders.contour.vertex';

import DataUniform from './shaders.data.uniform';
import DataFragment from './shaders.data.fragment';
import DataVertex from './shaders.data.vertex';

import VRUniform from './shaders.vr.uniform';
import VRFragment from './shaders.vr.fragment';
import VRVertex from './shaders.vr.vertex';

import LayerUniform from './shaders.layer.uniform';
import LayerFragment from './shaders.layer.fragment';
import LayerVertex from './shaders.layer.vertex';

import LocalizerUniform from './shaders.localizer.uniform';
import LocalizerFragment from './shaders.localizer.fragment';
import LocalizerVertex from './shaders.localizer.vertex';

export {
  ContourUniform as ContourUniformShader,
  ContourFragment as ContourFragmentShader,
  ContourVertex as ContourVertexShader,
  DataUniform as DataUniformShader,
  DataFragment as DataFragmentShader,
  DataVertex as DataVertexShader,
  VRUniform as VRUniformShader,
  VRFragment as VRFragmentShader,
  VRVertex as VRVertexShader,
  LayerUniform as LayerUniformShader,
  LayerFragment as LayerFragmentShader,
  LayerVertex as LayerVertexShader,
  LocalizerUniform as LocalizerUniformShader,
  LocalizerFragment as LocalizerFragmentShader,
  LocalizerVertex as LocalizerVertexShader,
};
